import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import styles from './PublicFooter.module.scss'

export const PublicFooter: FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'usercentrics' })

  const handleClick = () => {
    window.UC_UI?.showSecondLayer?.()
  }

  return (
    <footer className={styles.footer}>
      <button
        type='button'
        className={styles.button}
        onClick={handleClick}
        aria-label={t('aria_open_privacy_settings')}
      >
        {t('label')}
      </button>
    </footer>
  )
}